export const locationsProfilesConstants = {
    LOCATIONS_PROFILES_FETCH: 'LOCATIONS_PROFILES_FETCH',
    LOCATIONS_PROFILES_SUCCESS: 'LOCATIONS_PROFILES_SUCCESS',
    LOCATIONS_PROFILES_ERROR: 'LOCATIONS_PROFILES_ERROR',
    LOCATIONS_PROFILES_RESET: 'LOCATIONS_PROFILES_RESET',
};
